// extracted by mini-css-extract-plugin
export var borderRadius = "_ai-4";
export var large = "_ai-3";
export var logoContainer = "_ai-0";
export var nameLogo = "_ai-2";
export var small = "_ai-1";